/**
 * @file: Recipe.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 菜谱
 */
import request from '@/utils/request'

/**
 * 获取用餐时间（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function recipeDinnerTimeGet(data) {
  return request({
    type: 'biz',
    url: 'recipe/dinner/time/get',
    method: 'post',
    data
  })
}

/**
 * 午间菜谱-菜谱列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function recipeNoonDisherListGet(data) {
  return request({
    type: 'biz',
    url: 'recipe/noon/disher/list/get',
    method: 'post',
    data
  })
}

/**
 * 午间菜谱-营养分析（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function recipeNoonNutritionalElementListGet(data) {
  return request({
    type: 'biz',
    url: 'recipe/noon/nutritional/element/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Recipe.js